"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon/Icon");
const Text_1 = require("../Text/Text");
const Tooltip_1 = require("../Tooltip");
const Avatar_styles_1 = require("./Avatar.styles");
const getInitials_1 = require("./getInitials");
const AVATAR_VARIANTS = {
    extraLarge: { textVariant: "label", iconSize: 3 },
    large: { textVariant: "label", iconSize: 3 },
    medium: { textVariant: "note", iconSize: 3 },
    small: { textVariant: "caption", iconSize: 3 },
};
/**
 * @deprecated please use <Ds.Avatar> instead
 */
const Avatar = ({ name, size = "large", colour = "blue", showNameOnHover, }) => {
    const initials = (0, getInitials_1.getInitials)(name);
    const { textVariant, iconSize } = AVATAR_VARIANTS[size];
    const avatar = (react_1.default.createElement(Avatar_styles_1.StyledAvatarContainer, { colour: colour, size: size, "aria-label": name }, initials ? (react_1.default.createElement(Avatar_styles_1.StyledBlockText, { colour: "night", variant: textVariant, skinny: true, forwardedAs: "abbr" }, initials)) : (react_1.default.createElement(Icon_1.Icon, { name: "Person", title: name ? "" : "avatar", size: iconSize }))));
    if (!showNameOnHover) {
        return avatar;
    }
    return (react_1.default.createElement(Tooltip_1.TooltipProvider, null,
        react_1.default.createElement(Tooltip_1.Tooltip, null,
            react_1.default.createElement(Tooltip_1.TooltipTrigger, { asChild: true }, avatar),
            react_1.default.createElement(Tooltip_1.TooltipContent, null,
                react_1.default.createElement(Text_1.Text, { variant: "note" }, name)))));
};
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map